import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { getSearchDateParamFromMoment } from 'utils/search/searchDateParam';
import LoadingScreen from 'components/LoadingScreen';

/**
 * Renders the DynamicSearch component. Also the landing page for a redirect from an
 * invalid-date search-results URL (see ValidatedSearchProcessor/ValidatedOpenTicketSearch) —
 * it always starts a fresh one-way, one-adult, tomorrow search rather than a date picker, so
 * that context (round-trip, passengers) isn't recoverable from here; `location.search` is
 * forwarded so at least query params (coupons, utm_*, isExchange) survive.
 *
 * @param {Object} match - The match object from react-router.
 * @param {Object} location - The location object from react-router.
 */
const DynamicSearch = ({ match, location }) => {
  const history = useHistory();
  const { originSlug, destinationSlug } = match.params;
  const departureDate = getSearchDateParamFromMoment(moment().add(1, 'days'));
  const searchUrl = `/search/${originSlug}/${destinationSlug}/${departureDate}/p/A1/departures`;

  history.replace({ pathname: searchUrl, search: location.search });

  return <LoadingScreen />;
};

DynamicSearch.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      destinationSlug: PropTypes.string.isRequired,
      originSlug: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default DynamicSearch;
